import { render, staticRenderFns } from "./manage-customer.vue?vue&type=template&id=309a7809&"
import script from "./manage-customer.vue?vue&type=script&lang=js&"
export * from "./manage-customer.vue?vue&type=script&lang=js&"
import style0 from "./manage-customer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports